import Blockly from "blockly";

class ToolboxButton extends Blockly.ToolboxItem {
    /**
     * Constructor for a label in the toolbox.
     * @param {!Blockly.utils.toolbox.ToolboxItemInfo} toolboxItemDef The toolbox
     *    item definition. This comes directly from the toolbox definition.
     * @param {!Blockly.IToolbox} parentToolbox The toolbox that holds this
     *    toolbox item.
     * @implements {Blockly.ISelectableToolboxItem}
     */
    constructor(toolboxItemDef, parentToolbox) {
        super(toolboxItemDef, parentToolbox);
        /**
         * The button element.
         * @type {?HTMLButtonElement}
         */
        this.button = null;
        this.name = 'ToolboxButton';
        this.selected = false;
        // this.event = null;
    }

    /**
     * Init method for the label.
     * @override
     */
    init() {
        // Create the label.
        this.button = document.createElement('button');
        // Set the name.
        this.button.textContent = this.toolboxItemDef_['text'];
        this.button.id = this.toolboxItemDef_['name'];
        // Set the color.
        this.button.style.color = this.toolboxItemDef_['colour'];

        // this.button.id = "customRegister";

        // Any attributes that begin with css- will get added to a cssconfig.
        const cssConfig = this.toolboxItemDef_['cssconfig'];
        // Add the class.
        if (cssConfig) {
            this.button.classList.add(cssConfig['cta']);
        }
    }

    /**
     * @override 
     */
    isSelectable() {
        return true; 
    }
    /**
     * @override 
     */
    getName() {
        return this.name;
    }
    /**
     * @override 
     */
    getContents() {
        return '';
    }
    /**
     * @override 
     */
    onClick(onClickEvent) {
        console.log(onClickEvent)
        window.open("https://forms.gle/BHZgFdfTmongeRhi9");
    }
    /**
     * @override 
     */
    getClickTarget() {
        return this.button;
    }
    /**
     * @override 
     */
    setSelected() {
        this.selected ? false : true ;
    }

    /**
     * Gets the div for the toolbox item.
     * @return {HTMLButtonElement} The label element.
     * @override 
     */
    getDiv() {
        return this.button;
    }

}
// Object.assign(ToolboxCTA , Blockly.ToolboxItem);

Blockly.registry.register(
    Blockly.registry.Type.TOOLBOX_ITEM,
    'toolboxbutton',
    ToolboxButton);
